module.exports = __webpack_public_path__ + "img/header-title1.bcf9337b.png";